// Third party imports
import { useDispatch, useSelector } from 'react-redux';
import { jwtDecode } from 'jwt-decode';
// Project imports
import MedicalHealthApi from 'api/MedicalHealthApi';
import { useSnackMessages } from './useSnackMessages';
import * as actionTypes from 'store/actions';

export const useAuth = () => {
    const { status, user } = useSelector((state) => state.auth);
    const { msgBasicError } = useSnackMessages();
    const dispatch = useDispatch();

    /**
     *  Rewnew the token
     * @returns - {void}
     */
    const checkAuthToken = async () => {
        try {
            const token = localStorage.getItem('token');

            if (!token) {
                return startLogout();
            }

            MedicalHealthApi.defaults.headers.common['Authorization'] = `Bearer ${token}`;
            const { status, data } = await MedicalHealthApi.get('/auth/renew');

            if (status === 200) {
                const { newToken } = data;
                const { id, fname, lname, email } = jwtDecode(newToken);

                localStorage.setItem('token', newToken);
                MedicalHealthApi.defaults.headers.common['Authorization'] = `Bearer ${newToken}`;

                dispatch({ type: actionTypes.LOGIN, user: { id, fname, lname, email } });
            } else {
                startLogout();
            }
        } catch (e) {
            console.error(e);
            msgBasicError('Error al verificar el token de autenticación', true);
            startLogout();
        }
    };

    /**
     * Logout the user
     */
    const startLogout = () => {
        localStorage.clear();
        dispatch({ type: actionTypes.LOGOUT });
    };

    return {
        status,
        user,
        checkAuthToken,
        startLogout
    };
};
